import { event } from '@zillow/universal-analytics';
import { usePageProps, MediaStepper as MediaStepper$1, getCmsInfoForPage } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockMediaStepper = function BlockMediaStepper(_ref) {
  var innerBlocks = _ref.innerBlocks,
    _ref$attrs = _ref.attrs,
    animationTime = _ref$attrs.animationTime,
    collapseOthers = _ref$attrs.collapseOthers,
    blockId = _ref$attrs.id,
    reverse = _ref$attrs.reverse;
  var pageProps = usePageProps();
  return /*#__PURE__*/React.createElement(MediaStepper$1, {
    animationTime: animationTime,
    collapseOthers: collapseOthers,
    onStepClick: function onStepClick(div) {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2048
        envelope: {
          event_type_id: '2048',
          event_type_version_id: '1',
          event_template_id: '126',
          event_template_version_id: '1'
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: 'interaction',
          trigger_location_nm: 'cms',
          trigger_source_nm: 'cms_media_stepper',
          trigger_object_nm: 'no_trigger_object'
        },
        semantic: {
          semantic_event_nm: 'cms_click'
        },
        cms_info: Object.assign({
          block_id: blockId || '',
          block_type_cd: 'media_stepper',
          block_displayed_txt: div.textContent
        }, getCmsInfoForPage(pageProps))
      });
    },
    reverse: reverse
  }, innerBlocks.map(function (block) {
    var _block$innerBlocks$fi;
    var bodyBlock = block.innerBlocks.find(function (block) {
      return block.blockName === 'constellation/media-stepper-item-body';
    });
    var imageBlock = (_block$innerBlocks$fi = block.innerBlocks.find(function (block) {
      return block.blockName === 'constellation/media-stepper-item-media';
    })) === null || _block$innerBlocks$fi === void 0 ? void 0 : _block$innerBlocks$fi.innerBlocks.find(function (block) {
      return block.blockName === 'constellation/image';
    });

    // imageBlock.attrs:
    // ```
    // {
    //     "alt": "",
    //     "caption": "",
    //     "height": 316,
    //     "link": "https://bedrock.local/constellation/foo/storybook-mosaic/",
    //     "mediaId": 7,
    //     "sizeSlug": "large",
    //     "src": "https://bedrock.local/constellation/wp-content/uploads/sites/3/2023/08/storybook-mosaic.png",
    //     "width": 540,
    //     "id": "image-ff2fb280-75ac-44cd-934e-3c4a87ee03e4"
    //   }
    //   ```
    var imageProp = imageBlock ? {
      src: imageBlock.attrs.src,
      alt: imageBlock.attrs.alt,
      width: imageBlock.attrs.width,
      height: imageBlock.attrs.height
    } : undefined;
    return /*#__PURE__*/React.createElement(MediaStepper$1.Item, {
      key: block.attrs.id,
      heading: block.attrs.heading,
      image: imageProp
    }, !!bodyBlock && generateBlockList({
      blocks: bodyBlock.innerBlocks
    }));
  }));
};
BlockMediaStepper.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.bool.isRequired,
    animationTime: PropTypes.number.isRequired
  }).isRequired,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired
} : {};
var MediaStepper = BlockMediaStepper;

export { MediaStepper as default };
